// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"99422b94","239":"9b32583d","453":"85bc4d76","455":"6461206f"}[chunkId] + ".chunk.js";
};